/**
 * Admin API service — all calls guarded backend-side by role='admin'.
 */
const API = process.env.REACT_APP_BACKEND_URL;

function _token() {
  return localStorage.getItem('selora_token') || '';
}

function request(method, path, body) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, `${API}${path}`, true);
    xhr.setRequestHeader('Authorization', `Bearer ${_token()}`);
    if (body != null) xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = () => {
      let data = {};
      // Body may be empty/malformed on some endpoints; surface HTTP status either way.
      try { data = JSON.parse(xhr.responseText || '{}'); } catch (parseErr) { console.warn('adminService: bad JSON body', parseErr); }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.detail || `HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(body != null ? JSON.stringify(body) : null);
  });
}

const qs = (obj) => {
  const p = new URLSearchParams();
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v !== '' && v != null) p.set(k, String(v));
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const adminApi = {
  // users
  listUsers: (params) => request('GET', `/api/admin/users${qs(params)}`),
  changeRole: (userId, role) => request('POST', `/api/admin/users/${userId}/role`, { role }),
  deactivate: (userId) => request('POST', `/api/admin/users/${userId}/deactivate`),
  reactivate: (userId) => request('POST', `/api/admin/users/${userId}/reactivate`),
  // recordings
  listRecordings: (params) => request('GET', `/api/admin/recordings${qs(params)}`),
  recordingsStats: () => request('GET', '/api/admin/recordings/stats'),
  recordingUrl: (id) => request('GET', `/api/admin/recordings/${id}/playback-url`),
  softDeleteRecording: (id) => request('DELETE', `/api/admin/recordings/${id}`),
  // submissions
  listSubmissions: (params) => request('GET', `/api/admin/submissions${qs(params)}`),
  reviewSubmission: (id, payload) => request('PUT', `/api/submissions/${id}/review`, payload),
  // revenue
  revenueSummary: () => request('GET', '/api/admin/revenue/summary'),
  // audit
  listAudit: (params) => request('GET', `/api/admin/audit${qs(params)}`),
};
